import React from 'react';
import NavBar from "../NavBar/NavBar";
import {Trans} from "react-i18next";

const BasePage = (props) => {
  return (
    <>
      <a className="hidden" href="/">
        <header>
          <h1><Trans>Base.Title</Trans></h1>
        </header>
      </a>
      <div id={'wrapper'}>
        <NavBar/>
        <main className={props.className}>
          {props.children}
        </main>
      </div>
    </>
  );
};

export default BasePage;